import React, { Component } from 'react'
import Meta from 'components/layout/Meta';
import {actions} from "components/page/pageModule";

import './index.scss'

class Automl extends Component {

  constructor(props) {
    super(props)
  }

  render() {

    return (
      <div className="servicesWrap">
        <Meta location={this.props.location} title=""/>
        <div className="banner auto_banner">
          <div className="banner_cont">
            <h1>automl自动建模平台</h1>
            <p>通过自动建模平台，降低建模人员技术门槛与建模过程中的人工参与量，提升建模效率，为客户快速挖掘数据价值提供帮助。</p>
            <a href="./services/submitform">方案咨询</a>
          </div>
        </div>
        <div className="wrapPanel">
          <div className="panel jqr_panel">
            <h2><span>产品特色</span></h2>
            <ul className="jqr_pro_ul">
              <li>
                <img src={require('./images/icon_1.png')}/>
                <p>易用方便，高效建模</p>
                <div className="cont">
                  <p>1）使用门槛低，无需掌握SAS/Python编程语言亦可建模。</p>
                  <p>2) 自动帮助用户进行数据清洗、缺失值处理、 文本类特征编码等在线下处理比较耗时的数据前处理问题，提高了数据预 处理的效率;</p>
                  <p>3) 支持超参数和超参评估指标值联动的显示模式，用 户可以实时观测在每组超参数情况下的方案;</p>
                  <p>4）在自动调参功能的辅助下，省去了用户手动调参的工作，并且可以获得 效果更好的超参数;</p>
                </div>
              </li>
              <li>
                <img src={require('./images/icon_2.png')}/>
                <p>丰富的可视化图表与友好的人机交互</p>
                <div className="cont">
                  <p>1）平台自动生成数据画像、可以直观的呈现特征数据分布;</p>
                  <p>2）AUTO_ML 平台提供阈值和模型指标值联动，用户可以观测在不同阈值下， 模型各指标的取值情况，为用户进行 CUT_OFF_POINT 的选取带来方便。</p>
                </div>
              </li>
              <li>
                <img src={require('./images/icon_3.png')}/>
                <p>丰富精准的评估结果报告</p>
                <div className="cont">
                  <p>提供 ROC KS PR LIFT 特征重要性等曲线或Chart图，便于全面评估待部署模型</p>
                </div>
              </li>
            </ul>
            <ul className="jqr_pro_ul">
              <li>
                <img src={require('./images/icon_1.png')}/>
                <p>协作管理灵活高效</p>
                <div className="cont">
                  <p>1）方便灵活的用户账号管理与数据权限管理</p>
                  <p>2）平台会自动生成并保存所有探索记录及训练结果，便于随时查看 分析，易于多人协作管理，提高工作效率。</p>
                </div>
              </li>
              <li>
                <img src={require('./images/icon_2.png')}/>
                <p>充足的可扩展方案</p>
                <div className="cont">
                  <p>1）输入输出组件灵活方便对接外部系统或数据方便灵活</p>
                  <p>2）针对大规模数据提供Spark大数据版本扩展方案</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div className="wrapPanel panelCol">
          <div className="panel jqr_panel">
            <h2><span>应用领域</span></h2>
            <ul className="panel_ul">
              <li>
                <p className="title">金融</p>
                <img src={require('./images/icon_2.png')}/>
                <p>贷款、信用卡；风险评估建模、 ABC评分卡；反欺诈建模</p>
              </li>
              <li>
                <p className="title">教育</p>
                <img src={require('./images/icon_1.png')}/>
                <p>效率预测；客户分析；个性化推荐；客户防流失</p>
              </li>
              <li>
                <p className="title">其他行业</p>
                <img src={require('./images/icon_2.png')}/>
                <p>数据分析与建模</p>
              </li>
            </ul>
          </div>
        </div>
        <div className="wrapPanel">
          <div className="panel jqr_panel">
            <h2><span>应用领域</span></h2>
            <table>
              <thead>
                <tr><th></th><th>AUTOML自动建模</th><th>人工建模</th></tr>
              </thead>
              <tbody>
                <tr><td>数据预处理</td><td>对应复杂数据问题游刃有余</td><td>复杂数据问题人工处理难度大，效果往往达不到预期</td></tr>
                <tr><td>技术门槛</td><td>大大降低建模人员门槛</td><td>人员素质门槛高（招聘难度大、薪资成本高）</td></tr>
                <tr><td>建模效率</td><td>高，几小时~几天</td><td>低，几周~数月</td></tr>
                <tr><td>模型质量</td><td>直达中高级人工建模水平，质量稳定</td><td>依赖人员技术，质量参差不齐</td></tr>
                <tr><td>模型生命周期</td><td>长，且可预测</td><td>短，不稳定</td></tr>
                <tr><td>集成化</td><td>高</td><td>依赖工具</td></tr>
                <tr><td>模型管理</td><td>低</td><td>高（人员流动大、培训成本高）</td></tr>
                <tr><td>应用场景</td><td>多，扩展迅速</td><td>少，扩展缓慢</td></tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="wrapPanel panelCol">
          <div className="panel pro_panel">
            <h2><span>服务方式及流程</span></h2>
            <img src={require('./images/pro_2.png')}/>
            <ul>
              <li>试用体验</li>
              <li>签署服务协议</li>
              <li>组建服务团队</li>
              <li>沟通需求、定制解决方案</li>
              <li>测试、上线</li>
              <li>售后服务与支持</li>
            </ul>
          </div>
        </div>
      </div>
    )
  }
}


export default Automl



// WEBPACK FOOTER //
// ./modules/services/Automl.js